import React from 'react'

import {
  Box,
  Color,
  Display,
  Heading2,
  JustifyContent,
  Space,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { LandingPageButton, StepsWithImage } from '../../components'
import { HowGoustoFoodBoxesWorkSections, TargetUri, TrackingActions } from '../../types/tracking'
import type { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { HOW_IT_WORKS_SECTION } from './config'

export function HowItWorksSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <Box paddingH={[8, 20]} paddingV={16} bg={Color.NeutralGrey_50}>
      <Heading2 textAlign={[TextAlign.Left, null, null, TextAlign.Center]}>
        {HOW_IT_WORKS_SECTION.heading}
      </Heading2>
      <Space size={4} />
      <StepsWithImage steps={HOW_IT_WORKS_SECTION.steps} />
      <Space size={6} />
      <Box display={Display.Flex} justifyContent={JustifyContent.Center}>
        <LandingPageButton
          startOnboarding={startOnboarding}
          sectionName={HowGoustoFoodBoxesWorkSections.HOW_IT_WORKS_SECTION}
          target={TargetUri.SIGNUP}
          action={TrackingActions.CLICK_GET_STARTED}
        >
          {HOW_IT_WORKS_SECTION.ctaText}
        </LandingPageButton>
      </Box>
    </Box>
  )
}
